import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { HumanReadableNumber } from '../shared/utils/humanReadableNumber.util';

@Pipe({ name: 'numberWithLetter',  pure: false })
export class NumberWithLetterPipe implements PipeTransform {
	constructor() {}
	transform(n: number, noHtml = false): any {
		if (n !== undefined) {
			const str = HumanReadableNumber.transform(n, !noHtml);
			const np = new DecimalPipe('en');
			return noHtml ? str : (`<span title="${ np.transform(n)}">${str}</span>`);
		}
	}
}
